import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubmarketDetailTab from './SubmarketDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import { submarketType } from '../../types';
import './_styles_/SubmarketRow.css';
import { onActionKey } from '../../utils';

export const getValueMapping = (t) => ({
    active: [
        {
            from: true,
            to: t('misc.yes'),
        },
        {
            from: false,
            to: t('misc.no'),
        },
    ],
});

SubmarketRow.propTypes = {
    submarket: submarketType.isRequired,
};

function SubmarketRow(props) {
    const { submarket } = props;
    const { t } = useTranslation();
    const valueMapping = getValueMapping(t);
    const { isDetailVisible, toggleDetail } = useDetailHandler(submarket.id);
    return (
        <>
            <div className="rich-list-row submarket-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="submarket-header--values--name">{submarket.name}</div>
                <div className="submarket-header--values--code">{submarket.code}</div>
                <div className="submarket-header--values--active">{submarket.active ? valueMapping.active[0].to : valueMapping.active[1].to}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <SubmarketDetailTab submarket={submarket} />}
        </>
    );
}

export default SubmarketRow;
